// const baseUrl = "https://food-service-d1ed0096c526.herokuapp.com"; 
// production server on Heroku (out of service)
const baseUrl = "https://food-service-backend-n60w.onrender.com"; // production server on Render

export default baseUrl;